import { Component, Input, OnInit, booleanAttribute, inject } from '@angular/core';
import { CalioLucideIconComponent } from '@calio-lib/calio-lucide-icon/calio-lucide-icon.component';
import { FeatureService } from '@feature-services/feature.service';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-calio-lock-icon',
  templateUrl: './calio-lock-icon.component.html',
  styleUrls: ['./calio-lock-icon.component.scss'],
  imports: [CalioLucideIconComponent, NgbTooltipModule, TranslateModule]
})
export class CalioLockIconComponent implements OnInit {

  @Input() requiredSubscriptionPlan: string;
  @Input() msg: string;
  @Input({ transform: booleanAttribute }) showLockIcon = false;

  private featureService = inject(FeatureService);

  ngOnInit(): void {
    if (this.requiredSubscriptionPlan) {
      this.showLockIcon = !(this.featureService.hasFeature(this.requiredSubscriptionPlan));
    }

    if (!this.msg && this.requiredSubscriptionPlan) {
      if (typeof this.requiredSubscriptionPlan === 'string') {
        this.msg = this.featureService.featureNotAvailable(this.requiredSubscriptionPlan, false) as string;
        if (!this.msg) {
          this.msg = 'your_subscription_component.feature_not_available_for_subscribed_plan';
        }
      }
    } else if (!this.msg) {
      this.msg = 'your_subscription_component.feature_not_available_for_subscribed_plan';
    }
  }
}
